import Link from "next/link";
import { type ReactNode } from "react";

import { cn } from "@/lib/utils";

const TEXT_LINK_CLASS =
  "w-fit py-s font-ppMori text-paragraph-sm text-content-primary underline hover:text-tint-black-70 active:text-functional-blue";

type TextLinkProps = {
  children: ReactNode;
  className?: string;
} & (
  { href: string; onClick?: () => void } | { href?: never; onClick: () => void }
);

const TextLink = ({ href, onClick, className, children }: TextLinkProps) => {
  if (href !== undefined) {
    return (
      <Link
        href={href}
        className={cn(TEXT_LINK_CLASS, className)}
        {...(onClick !== undefined ? { onClick } : {})}
      >
        {children}
      </Link>
    );
  }
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(TEXT_LINK_CLASS, className)}
    >
      {children}
    </button>
  );
};

export default TextLink;
